import "./DESetup.scss";
import LawOne from "../../../assests/images/LawOne.png";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { FiEdit, FiDownload } from "react-icons/fi";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import Modal from "../../ReuseableComponents/Modal/Modal";
import DeleteJointResolutionDocument from "./SearchDocument/DeleteDocuments/DeleteJointResolutionDocument";
import Loader from "../../ReuseableComponents/Loader/Loader";
import { MdEdit } from "react-icons/md";
import RCText from "./Text/RCText";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import RC7 from "../../../assests/images/RC/RC7.png";
import RC6 from "../../../assests/images/RC/RC6.png";
import RC5 from "../../../assests/images/RC/RC5.png";
import RC4 from "../../../assests/images/RC/RC4.png";
import RC3 from "../../../assests/images/RC/RC3.png";
import RC2 from "../../../assests/images/RC/RC2.png";
import RC1 from "../../../assests/images/RC/RC1.png";

export interface StaffProps {
  isStaff: any;
  latestJoint: any;
  loading: any;
  setLoading: any;
  webTemplate: any;
  handleButtonClick: any;
  disabledButtons: any;
  cursor: any;
}

const JointResolutionLaws = ({
  isStaff,
  latestJoint,
  loading,
  setLoading,
  webTemplate,
  handleButtonClick,
  disabledButtons,
  cursor,
}: StaffProps) => {
  let img: any;
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [showTextModal, setShowTextModal] = useState(false);
  const [note, setNote] = useState<any>();
  const [docView, setDocView] = useState(false);
  const [onDemandData, setOnDemandData] = useState<any>();
  const [demandLoading, setDemandLoading] = useState(false);

  const handleOpenDeleteModal = () => {
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };
  const handleOpenTextModal = () => {
    setShowTextModal(true);
    setNote(webTemplate?.latest_rc_body_en);
  };

  const handleCloseTextModal = () => {
    setShowTextModal(false);
  };

  return (
    <div className="basic-laws-container">
      <div className="headings">
        <div className="topline">
          <h1>Latest Registered Joint Resolutions Laws</h1>
          <Link
            to="/upload-documents-en"
            style={{ display: isStaff ? "flex" : "none" }}
          >
            <button className="add-new">Add New</button>
          </Link>
        </div>
        <div className="topline">
          <p>
            {webTemplate?.latest_rc_body_en}{" "}
            <MdEdit
              style={{ display: isStaff ? "inline-block" : "none" }}
              className="edit-icon"
              onClick={handleOpenTextModal}
            />
          </p>
          {docView ? (
            <div className="togle">
              <h4 className="toggle-title">GRID</h4>
              <BsToggleOff
                className="toggle-icon"
                onClick={() => setDocView(false)}
              />
            </div>
          ) : (
            <div className="togle">
              <h4 className="toggle-title">CAROUSEL</h4>
              <BsToggleOn
                className="toggle-icon"
                onClick={() => setDocView(true)}
              />
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <>
          <Loader width={330} />
          <h4
            style={{
              textAlign: "center",
              color: "#083052",
              fontSize: "16px",
              margin: 0,
            }}
          >
            Searching for Joint Resolutions Laws
          </h4>
        </>
      ) : (
        <>
          {docView ? (
            <div className="basic-laws">
              {latestJoint?.map((items: any) => {
                if (items?.id === 41106) {
                  img = RC7;
                } else if (items?.id === 41105) {
                  img = RC6;
                } else if (items?.id === 41104) {
                  img = RC5;
                } else if (items?.id === 41103) {
                  img = RC4;
                } else if (items?.id === 41102) {
                  img = RC3;
                } else if (items?.id === 41101) {
                  img = RC2;
                } else {
                  img = RC1;
                }
                return (
                  <div className="basic-laws-card" key={items?.id}>
                    <img src={img} alt="RCLaws" />
                    <h3>{items?.name.slice(0, 90)}</h3>
                    <div
                      className="card-buttons"
                      style={{ display: isStaff ? "flex" : "none" }}
                    >
                      {items?.file !== null ? (
                        <a
                          href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <AiOutlineEye /> / <FiDownload />
                        </a>
                      ) : (
                        <>
                          {demandLoading && onDemandData.id === items.id ? (
                            <div>
                              <Loader width={60} />
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "#fff",
                                  fontSize: "12px",
                                }}
                              >
                                Downloading
                              </p>
                            </div>
                          ) : (
                            <button
                              style={{ cursor: cursor }}
                              className="download-button"
                              key={items.doc_id}
                              onClick={() => handleButtonClick(items)}
                              disabled={disabledButtons.some(
                                (button: any) =>
                                  button.doc_id === items.doc_id
                              )}
                            >
                              <AiOutlineEye /> / <FiDownload />
                            </button>
                          )}
                        </>
                      )}
                      <Link to={`/update-documents-en?id=${items.id}`}>
                        <FiEdit />
                      </Link>
                      <button
                        className="delete-button"
                        onClick={() => {
                          handleOpenDeleteModal();
                          setDeleteID(items?.id);
                        }}
                      >
                        <AiOutlineDelete />
                      </button>
                    </div>
                    <div
                      className="card-buttons"
                      style={{ display: isStaff ? "none" : "flex" }}
                    >
                      {items?.file !== null ? (
                        <a
                          href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="view-download"
                        >
                          View / Download
                        </a>
                      ) : (
                        <>
                          {demandLoading && onDemandData.id === items.id ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <Loader width="" />
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "#fff",
                                  fontSize: "12px",
                                  margin: 0,
                                }}
                              >
                                Downloading
                              </p>
                            </div>
                          ) : (
                            <button
                              style={{ cursor: cursor }}
                              className="download-button"
                              key={items.doc_id}
                              onClick={() => handleButtonClick(items)}
                              disabled={disabledButtons.some(
                                (button: any) =>
                                  button.doc_id === items.doc_id
                              )}
                            >
                              View / Download
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <Swiper
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                1200: {
                  slidesPerView: 4,
                },
                990: {
                  slidesPerView: 3,
                },
                600: {
                  slidesPerView: 2,
                },
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              className="mySwiper"
            >
              <div className="basic-laws">
                {latestJoint?.map((items: any) => {
                if (items?.id === 41106) {
                  img = RC7;
                } else if (items?.id === 41105) {
                  img = RC6;
                } else if (items?.id === 41104) {
                  img = RC5;
                } else if (items?.id === 41103) {
                  img = RC4;
                } else if (items?.id === 41102) {
                  img = RC3;
                } else if (items?.id === 41101) {
                  img = RC2;
                } else {
                  img = RC1;
                }
                  return (
                    <SwiperSlide>
                      <div className="basic-laws-card" key={items?.id}>
                        <img src={img} alt="RCLaw" />
                        <h3>{items?.name.slice(0, 90)}</h3>
                        <div
                          className="card-buttons"
                          style={{ display: isStaff ? "flex" : "none" }}
                        >
                          {items?.file !== null ? (
                            <a
                              href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <AiOutlineEye /> / <FiDownload />
                            </a>
                          ) : (
                            <>
                              {demandLoading && onDemandData.id === items.id ? (
                                <div>
                                  <Loader width={60} />
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: "#fff",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Downloading
                                  </p>
                                </div>
                              ) : (
                                <button
                                  style={{ cursor: cursor }}
                                  className="download-button"
                                  key={items.doc_id}
                                  onClick={() => handleButtonClick(items)}
                                  disabled={disabledButtons.some(
                                    (button: any) =>
                                      button.doc_id === items.doc_id
                                  )}
                                >
                                  <AiOutlineEye /> / <FiDownload />
                                </button>
                              )}
                            </>
                          )}
                          <Link to={`/update-documents-en?id=${items.id}`}>
                            <FiEdit />
                          </Link>
                          <button
                            className="delete-button"
                            onClick={() => {
                              handleOpenDeleteModal();
                              setDeleteID(items?.id);
                            }}
                          >
                            <AiOutlineDelete />
                          </button>
                        </div>
                        <div
                          className="card-buttons"
                          style={{ display: isStaff ? "none" : "flex" }}
                        >
                          {items?.file !== null ? (
                            <a
                              href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-download"
                            >
                              View / Download
                            </a>
                          ) : (
                            <>
                              {demandLoading && onDemandData.id === items.id ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    width: "100%",
                                  }}
                                >
                                  <Loader width="" />
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: "#fff",
                                      fontSize: "12px",
                                      margin: 0,
                                    }}
                                  >
                                    Downloading
                                  </p>
                                </div>
                              ) : (
                                <button
                                  style={{ cursor: cursor }}
                                  className="download-button"
                                  key={items.doc_id}
                                  onClick={() => handleButtonClick(items)}
                                  disabled={disabledButtons.some(
                                    (button: any) =>
                                      button.doc_id === items.doc_id
                                  )}
                                >
                                  View / Download
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </div>
            </Swiper>
          )}
        </>
      )}
      <div className="col-md-3">
        {showDeleteModal && (
          <Modal
            title="Delete Document"
            content={
              <DeleteJointResolutionDocument
                handleCloseDeleteModal={handleCloseDeleteModal}
                deleteID={deleteID}
              />
            }
            onClose={handleCloseDeleteModal}
          />
        )}
      </div>
      <div className="col-md-3">
        {showTextModal && (
          <Modal
            title="Update Text"
            content={
              <RCText
                note={note}
                setNote={setNote}
                handleCloseTextModal={handleCloseTextModal}
                loading={loading}
                setLoading={setLoading}
              />
            }
            onClose={handleCloseTextModal}
          />
        )}
      </div>
    </div>
  );
};

export default JointResolutionLaws;
